import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-technical-work-notification',
  imports: [TranslateModule],
  templateUrl: './technical-work-notification.component.html',
  styleUrl: './technical-work-notification.component.scss',
})
export class TechnicalWorkNotificationComponent {
  maxWidth = input();
  wrapperPaddings = input();
}
